import Service, { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import ApiService from './api';
import { CampaignType } from 'cio/models/campaign';

export interface CampaignTemplate {
  templateId: string | null;
  title: string;
  image: string;
  description: string;
  time?: string;
  messages?: string;
  type?: CampaignType;
}

// These campaigns should come from the backend eventually
export const CAMPAIGN_TEMPLATES: CampaignTemplate[] = [
  {
    templateId: null,
    title: 'Create from scratch',
    image: new URL('cio/assets/images/campaign-templates/create-from-scratch.png', import.meta.url).toString(),
    description:
      'A great place to start if you want to explore the workflow builder or create a campaign you already have in mind.',
  },
  {
    title: 'Re-engage inactive users',
    image: new URL('cio/assets/images/campaign-templates/re-engage-inactive-users.png', import.meta.url).toString(),
    description: 'Identify customers at risk of churning or inactivity and re-engage them.',
    time: '15 days',
    messages: '5 messages',
    type: CampaignType.Behavioral,
    templateId: 'reengage',
  },
  {
    title: 'Order confirmation',
    image: new URL('cio/assets/images/campaign-templates/order-confirmation.png', import.meta.url).toString(),
    description: 'Send order confirmation emails when customers make a purchase.',
    time: '1 day',
    messages: '2 messages',
    type: CampaignType.Transactional,
    templateId: 'confirmation',
  },
  {
    title: 'Onboarding campaign',
    image: new URL('cio/assets/images/campaign-templates/onboarding-campaign.png', import.meta.url).toString(),
    description: "Help new customers understand the value they'll receive from your product.",
    time: '3 days',
    messages: '3 messages',
    type: CampaignType.Behavioral,
    templateId: 'onboarding',
  },
  {
    title: 'Anniversary campaign',
    image: new URL('cio/assets/images/campaign-templates/anniversary-campaign.png', import.meta.url).toString(),
    description: 'Send messages on birthdays, anniversaries, and other recurring dates to keep customers engaged.',
    time: '1 day',
    messages: '1 message',
    type: CampaignType.Date,
    templateId: 'anniversary',
  },
];

export default class CampaignTemplatesService extends Service {
  @service api!: ApiService;

  createCampaignFromTemplate = task(async (template: string) => {
    let { campaign_id: campaignId } = await this.api.post('create_campaign_from_template', {
      pathScope: 'environment',
      data: {
        template,
      },
    });

    return campaignId;
  });
}

// DO NOT DELETE: this is how TypeScript knows how to look up your services.
declare module '@ember/service' {
  interface Registry {
    'campaign-templates': CampaignTemplatesService;
  }
}
